document.addEventListener('DOMContentLoaded', function () {
  if (window.__artcanvasMetafieldProductSlidersInit) return;
  window.__artcanvasMetafieldProductSlidersInit = true;

  /* ─────────────────────────────────────────────────────────────────────
     SHUFFLE + TRIM
     Must run SYNCHRONOUSLY before Swiper touches the DOM.
     Targets only wrappers inside [data-ymal-shuffle="true"].
     Slides are hidden via CSS until shuffle is complete to prevent flash.
  ───────────────────────────────────────────────────────────────────── */
  function fisherYatesShuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
    }
    return arr;
  }

  var shuffleContainers = document.querySelectorAll('[data-ymal-shuffle="true"]');

  shuffleContainers.forEach(function (swiperEl) {
    var wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    var max = parseInt(swiperEl.getAttribute('data-ymal-max'), 10) || 12;

    /*
     * Only select ORIGINAL slides — exclude any Swiper-cloned duplicates
     * (clones carry data-swiper-slide-index). At DOMContentLoaded Swiper
     * hasn't run yet so there should be no clones, but guard anyway.
     */
    var slides = Array.from(
      wrapper.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')
    );

    if (slides.length <= max) {
      /*
       * Not enough slides to produce variety — nothing to trim,
       * but still shuffle so order varies on each page load.
       */
      if (slides.length > 1) {
        fisherYatesShuffle(slides);
        slides.forEach(function (slide) { wrapper.appendChild(slide); });
      }
      return;
    }

    /* Shuffle the full pool */
    fisherYatesShuffle(slides);

    /* Remove slides beyond max from the DOM entirely */
    for (var i = max; i < slides.length; i++) {
      if (slides[i].parentNode) {
        slides[i].parentNode.removeChild(slides[i]);
      }
    }

    /* Re-insert the kept slides in shuffled order */
    var kept = slides.slice(0, max);
    kept.forEach(function (slide) { wrapper.appendChild(slide); });
  });

  /* ─────────────────────────────────────────────────────────────────────
     SWIPER INIT  (original code, unchanged)
  ───────────────────────────────────────────────────────────────────── */
  var sliders = document.querySelectorAll(
    '.you-may-also-like-slider-container .product-grid.swiper, .designer-suggestion-slider-container .product-grid.swiper'
  );
  function revealContainer(container) {
    if (container) {
      container.style.visibility = 'visible';
      container.style.minHeight = '';
    }
  }

  function revealSliderContainer(el) {
    revealContainer(el.closest('[data-ymal-container]'));
  }

  if (!sliders || sliders.length === 0) {
    document.querySelectorAll('[data-ymal-container]').forEach(revealContainer);
    return;
  }
  if (typeof Swiper === 'undefined') {
    sliders.forEach(revealSliderContainer);
    return;
  }

  function updateSwiperPagination(swiperRootEl, swiperInstance) {
    if (!swiperRootEl) return;
    var colorarr = ['blue', 'purple', 'green', 'red', 'orange', 'yellow'];
    var bullets = Array.from(
      swiperRootEl.querySelectorAll('.swiper-pagination .swiper-pagination-bullet')
    );
    if (!bullets.length) return;

    var activeIdx = -1;
    for (var bi = 0; bi < bullets.length; bi++) {
      if (bullets[bi].classList.contains('swiper-pagination-bullet-active')) {
        activeIdx = bi;
        break;
      }
    }

    if (activeIdx < 0) {
      if (
        swiperInstance &&
        typeof swiperInstance.snapIndex === 'number' &&
        swiperInstance.snapIndex >= 0
      ) {
        activeIdx = swiperInstance.snapIndex;
      } else if (swiperInstance) {
        var spg =
          swiperInstance.params && swiperInstance.params.slidesPerGroup
            ? swiperInstance.params.slidesPerGroup
            : 1;
        var ri =
          typeof swiperInstance.realIndex === 'number'
            ? swiperInstance.realIndex
            : swiperInstance.activeIndex || 0;
        activeIdx = Math.floor(ri / Math.max(spg, 1));
      } else {
        activeIdx = 0;
      }
    }

    bullets.forEach(function (bulletEl, i) {
      colorarr.forEach(function (c) {
        bulletEl.classList.remove('swiper-' + c);
      });
      bulletEl.classList.add('swiper-' + colorarr[i % colorarr.length]);
      bulletEl.classList.toggle('process', i <= activeIdx);
    });
  }

  sliders.forEach(function (el) {
    var wrapper = el.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    function initSwiper() {
      var prevEl = el.querySelector('.swiper-button-prev');
      var nextEl = el.querySelector('.swiper-button-next');
      var paginationEl = el.querySelector('.swiper-pagination');

      var config = {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30,
        loop: true,
        watchOverflow: true,
        breakpoints: {
          1025: {
            slidesPerView: 4,
            slidesPerGroup: 4
          }
        }
      };

      if (prevEl || nextEl) {
        config.navigation = { prevEl: prevEl, nextEl: nextEl };
      }
      if (paginationEl) {
        config.pagination = { el: paginationEl, clickable: true };
      }

      config.on = {
        init: function (swiper) {
          requestAnimationFrame(function () {
            updateSwiperPagination(el, swiper);
          });
        },
        paginationUpdate: function (swiper) {
          requestAnimationFrame(function () {
            updateSwiperPagination(el, swiper);
          });
        },
        update: function (swiper) {
          requestAnimationFrame(function () {
            updateSwiperPagination(el, swiper);
          });
        },
        slideChange: function (swiper) {
          requestAnimationFrame(function () {
            updateSwiperPagination(el, swiper);
          });
        },
        slideChangeTransitionEnd: function (swiper) {
          requestAnimationFrame(function () {
            updateSwiperPagination(el, swiper);
          });
        }
      };

      el._swiper = new Swiper(el, config);

      // Reveal container now that Swiper is fully initialised
      revealSliderContainer(el);
    }

    function destroySwiper() {
      if (el._swiper && el._swiper.destroy) {
        el._swiper.destroy(true, true);
      }
      el._swiper = null;
    }

    function enable() {
      if (el._enabled) return;
      initSwiper();
      el._enabled = true;
    }

    function disable() {
      if (el._enabled) {
        destroySwiper();
        el._enabled = false;
      }
      // Still reveal on mobile where Swiper is intentionally off
      revealSliderContainer(el);
    }

    function evaluate() {
      if (window.innerWidth >= 768) {
        enable();
      } else {
        disable();
      }
    }

    evaluate();
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(evaluate, 150);
    });
  });
});
